<template>
    <div>
        <div class="title">Ustaw nowe hasło</div>
        
        <div class="message has-icon is-info" v-if="isCheckingToken">
            <div class="message-body has-text-weight-semibold">
            <span class="icon"><i class="far fa-info-circle"></i></span>
                <p>Trwa weryfikacja kod resetującego hasło.</p>
            </div>
        </div>

        <div class="message has-icon is-success" :class="{'is-hidden': !isSuccess}">
            <div class="message-body has-text-weight-semibold">
            <span class="icon"><i class="far fa-smile"></i></span>
                <p>Twoje hasło zostało zmienione.</p>
            </div>
        </div>

        <error-message :msg="errorMsg"></error-message>
        <div class="has-text-centered" v-if="showBackBtn">
            <router-link class="has-text-danger" to="/">Powrót do formularza resetującego hasło</router-link>
        </div>

        <fieldset :class="{'is-loading': isLoading}" v-if="showForm">
            <form @submit.prevent="setPassword">
                <div class="field">
                    <label class="label">Nowe hasło</label>
                    <div class="control">
                        <password-field v-model="password"></password-field>
                    </div>
                </div>

                <div class="field">
                    <label class="label">Potwierdź hasło</label>
                    <div class="control">
                        <password-field v-model="passwordConfirmation"></password-field>
                    </div>
                </div>
                
                <button type="submit" class="button is-fullwidth is-medium is-dark" :disabled="!canSubmit">Ustaw hasło</button>
            </form>
        </fieldset>
    </div>
</template>

<script>
export default {
    components: {
        ErrorMessage: () => import("@/components/ErrorMessage"),
        PasswordField: () => import("@/components/PasswordField")
    },
    computed: {
        canSubmit() {
            return this.password.length >= 6 && this.password == this.passwordConfirmation
        }
    },
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            token: null,
            isLoading: false,
            isCheckingToken: false,
            errorMsg: null,
            showBackBtn: false,
            isSuccess: false,
            showForm: false
        }
    },
    methods: {
        setPassword() {
            this.isLoading = true;
            this.errorMsg = null;
            this.axios.post("/setPassword", 
            {
                "token": this.token,
                "password": this.password
            })
            .then(() => {
                this.showForm = false;
                this.isSuccess = true;
                this.showBackBtn = true;
            })
            .catch((error) => {
                this.errorMsg = error.response.data.message;
            })
            .finally(() => {
                this.isLoading = false;
            })
        }
    },
    mounted() {
        this.token = this.$route.query.token;
        if(!this.token) {
            this.errorMsg = "Nieprawidłowy kod resetujący hasło.";
        }
        else {
            this.isLoading = true;
            this.isCheckingToken = true;
            this.axios.get("checkResetPasswordToken/" + this.token)
            .then(() => {
                this.showForm = true;
            })
            .catch((error) => {
                this.errorMsg = error.response.data.message;
                this.showBackBtn = true;
            })
            .finally(() => {
                this.isLoading = false;
                this.isCheckingToken = false;
            })
        }
    }
}
</script>